import { jsx as _jsx } from "react/jsx-runtime";
import { Add, Remove } from "@mui/icons-material";
import { IconButton, InputAdornment, styled } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { Input } from "./Input";
const StyledIconButton = styled(IconButton)({
    padding: 0
});
export const StepperInput = (props)=>{
    const formContext = useFormContext();
    const currentValue = useWatch({
        control: formContext.control,
        name: props.name
    });
    const onMaxClick = ()=>{
        const value = currentValue + props.step;
        formContext.setValue(props.name, value, {
            shouldValidate: true
        });
        if (props.onChange) {
            props.onChange(value);
        }
    };
    const onMinClick = ()=>{
        const value = currentValue - props.step;
        formContext.setValue(props.name, value, {
            shouldValidate: true
        });
        if (props.onChange) {
            props.onChange(value);
        }
    };
    return /*#__PURE__*/ _jsx(Input, {
        ...props,
        endAdornment: props.disabled ? undefined : /*#__PURE__*/ _jsx(InputAdornment, {
            position: "end",
            children: /*#__PURE__*/ _jsx(StyledIconButton, {
                "aria-label": "increase value",
                "data-testid": `${props.name}Increase`,
                disabled: currentValue >= props.max || props.readOnly,
                onClick: onMaxClick,
                children: /*#__PURE__*/ _jsx(Add, {})
            })
        }),
        onChange: props.onChange,
        startAdornment: props.disabled ? undefined : /*#__PURE__*/ _jsx(InputAdornment, {
            position: "start",
            children: /*#__PURE__*/ _jsx(StyledIconButton, {
                "aria-label": "decrease value",
                "data-testid": `${props.name}Decrease`,
                disabled: currentValue <= props.min || props.readOnly,
                onClick: onMinClick,
                children: /*#__PURE__*/ _jsx(Remove, {})
            })
        }),
        textAlign: props.disabled ? 'start' : 'center'
    });
};
StepperInput.displayName = 'StepperInput';

//# sourceMappingURL=StepperInput.js.map